package com.partejar.app.core.ui.components

import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.BoxWithConstraintsScope
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp

enum class PartejarWindowSize { COMPACT, MEDIUM, EXPANDED }

object PartejarLayout {
    val medium = 600.dp
    val expanded = 1024.dp
    val contentMaxWidth = 1280.dp
    val readingMaxWidth = 760.dp
    val formMaxWidth = 480.dp
    val dockMaxWidth = 640.dp
    val desktopDockHeight = 72.dp
    val desktopDockBottomMargin = 24.dp
    val desktopDockClearance = desktopDockHeight + desktopDockBottomMargin
}

private val LocalWindowSize = staticCompositionLocalOf { PartejarWindowSize.COMPACT }

val partejarWindowSize: PartejarWindowSize
    @Composable get() = LocalWindowSize.current

@Composable
fun PartejarResponsive(
    modifier: Modifier = Modifier,
    content: @Composable BoxWithConstraintsScope.() -> Unit
) {
    BoxWithConstraints(modifier) {
        val size = when {
            maxWidth < PartejarLayout.medium -> PartejarWindowSize.COMPACT
            maxWidth < PartejarLayout.expanded -> PartejarWindowSize.MEDIUM
            else -> PartejarWindowSize.EXPANDED
        }
        CompositionLocalProvider(LocalWindowSize provides size) { content() }
    }
}
